import { render, staticRenderFns } from "./AppRefreshButton.vue?vue&type=template&id=f9fc0b10&"
import script from "./AppRefreshButton.vue?vue&type=script&lang=js&"
export * from "./AppRefreshButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports